// Runtime configuration. The browser bundle has every value below statically
// replaced by Bun's `define` at build time (scripts/build.ts), so each read
// MUST be a literal `process.env.FOO` member expression — a dynamic
// `process.env[key]` would not be replaced and would throw in the browser where
// `process` doesn't exist. In `bun test`, `process.env` is available natively.

/** Treat empty string (unset-at-build) as undefined. */
const val = (v: string | undefined): string | undefined => (v == null || v === "" ? undefined : v);

// Literal accesses — one per variable so the bundler can replace each.
const TEST_MODE = val(process.env.TEST_MODE);
const NODE_ENV = val(process.env.NODE_ENV);
const RAW_AUTH_PROVIDER = val(process.env.AUTH_PROVIDER);

function queryFlag(name: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    return new URLSearchParams(window.location.search).get(name) === "1";
  } catch {
    return false;
  }
}

export const IS_TEST = TEST_MODE === "1" || queryFlag("test");

/** Dev-only routes and the states gallery are enabled outside production. */
export const IS_DEV = NODE_ENV !== "production" || IS_TEST;

export const SUPABASE_URL = val(process.env.SUPABASE_URL) ?? "";
export const SUPABASE_ANON_KEY = val(process.env.SUPABASE_ANON_KEY) ?? "";
export const TMDB_API_KEY = val(process.env.TMDB_API_KEY) ?? "";

/** Which auth provider to use — 'local' for the harness, 'discord' in prod. */
export const AUTH_PROVIDER: "local" | "discord" =
  (RAW_AUTH_PROVIDER as "local" | "discord") ?? (IS_TEST ? "local" : "discord");

/** In test mode, MSW mocks all TMDB/LLM traffic unless REAL_NETWORK=1 (§13.4). */
export const REAL_NETWORK = val(process.env.REAL_NETWORK) === "1";

/** A frozen "now" for deterministic date labels in test mode (§13.9). */
export function nowDate(): Date {
  return new Date();
}
